import React, { FC } from "react"
import { Box, Flex, FlexProps } from "@chakra-ui/react"

export const ALL_VARIANT_TEXT = "Choose both options"

export const AllVariantButton: FC<FlexProps & { iconColor?: string; iconBgColor?: string }> = ({
  iconColor = "currentColor",
  iconBgColor = "color-mix(in srgb, currentColor 50%, transparent)",
  ...props
}) => (
  <Flex alignItems="center" justifyContent="center" cursor="pointer" {...props}>
    <Box
      borderRadius="full"
      w="24px"
      h="24px"
      border="2px"
      borderColor={iconColor}
      bgColor={iconBgColor}
      marginRight={2}
    />
    <Box>{ALL_VARIANT_TEXT}</Box>
  </Flex>
)
